import Url from './url';
import ModelContainer from '@core/scripts/components/model-container';
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import Messages from '@core/scripts//components/messages';
import sendBeacon from '@core/scripts/helper/send-beacon';

//event types
const EventType = {
    DISPLAY_PRODUCT_DETAILS: "DISPLAY_PRODUCT_DETAILS",
    ADD_TO_CART: "ADD_TO_CART_PDD",
    REMOVE_FROM_CART: "REMOVE_FROM_CART_PDD"
};

function trigger(eventType, event) {
    if(!eventType) {
        return null;
    }

    const url = Url.toAbsolute(`/ajax/nitro/beacon/${eventType}/`);
    return sendBeacon(url, event);
}

function sendTracedEvent(eventType) {
    let pageViewId = ModelContainer.get("pageViewId");
    const platformAttributesContainer = document.querySelector('[jsh-platform-attributes]');
    if (platformAttributesContainer) {
        if (platformAttributesContainer.pageViewId) {
            pageViewId = platformAttributesContainer.pageViewId;
        }
        return this.trigger(eventType, {"pageViewId": pageViewId});
    }
    return "";
}

function triggerNewPageEvent(pageType, newPageViewId) {
    const pageViewId = newPageViewId.replace(/"/g, '');
    const platformAttributesContainer = document.querySelector('[jsh-platform-attributes]');
    if(platformAttributesContainer) {
        platformAttributesContainer.pageViewId = pageViewId;
        const eventPayload = {"pageType": pageType, "pageViewId": pageViewId}
        if(pageType === "aop") {
            return MessageBroker.publish(Messages.ARTICLE_OVERVIEW.OPENED, eventPayload);
        }
    }
    return "";
}

export default {
    EventType,
    trigger,
    sendTracedEvent,
    triggerNewPageEvent
};